module.exports = {"complaintPreviewTitle":"Podgląd zgłoszenia","complaintHeaderTitle":"Informacje podstawowe","complaintNumber":"Numer zgłoszenia","complaintType":"Rodzaj zgłoszenia","complaintDate":"Data utworzenia","customerName":"Osoba kontaktowa:","customerEmail":"Email:","customerPhone":"Telefon:","customerAddress":"Adres:","companyName":"Podmiot:","companyTax":"NIP:","erpStatus":"Status w systemie ERP","notes":"Uwagi:"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ComplaintPreview/translate.json
// module id = 286
// module chunks = 0